import type { ReactNode } from 'react';
import { AppHeader } from './AppHeader';
import './AuthFormCard.css';

interface AuthFormCardProps {
  title: string;
  children: ReactNode;
}

export function AuthFormCard({ title, children }: AuthFormCardProps) {
  return (
    <div className="auth-form-page">
      <AppHeader user={null} title="KI Expert" showLogout={false} />
      <div className="auth-form-container">
        <div className="auth-form-card">
          <header className="auth-form-header">
            <p>{title}</p>
          </header>
          <main className="auth-form-main">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
}
